// src/pages/contact.jsx
import React, { useState } from "react";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("http://localhost:5000/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    const data = await response.json();

    if (response.ok) {
      alert("Message Sent Successfully!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } else {
      alert(`Error: ${data.error}`);
    }
  } catch (error) {
    alert("Server error. Please try again later.");
  }
};


  return (
    <div className="page">
      <section className="section section-highlight">
        <h2>Contact Us</h2>
        <p className="muted">
          Share your project requirements and we’ll get back to you with a
          customised solution.
        </p>

        <div className="contact-section">
          <div className="contact-info">
            <p>Phone: <a href="tel:+919426948038">+91-9426948038</a></p>
            <p>Email: <a href="mailto:rooftechhelp@gmail.com">rooftechhelp@gmail.com</a></p>
            <p>Location: Your City / Region</p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                id="phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="btn-primary"
              disabled={submitting}
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>


            {status.message && (
              <p
                className="muted"
                style={{
                  marginTop: "0.7rem",
                  color: status.type === "success" ? "#4ade80" : "#f97373"
                }}
              >
                {status.message}
              </p>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}

export default Contact;
